import { render, staticRenderFns } from "./AuditTask.vue?vue&type=template&id=5bce332e"
import script from "./AuditTask.vue?vue&type=script&lang=ts"
export * from "./AuditTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports